import { useEffect, useRef, useState } from 'react';

export const COUNT_UP_DURATION = 800; // ms, massimo consentito

// easing out cubic
export const countUpEase = (t) => 1 - Math.pow(1 - t, 3);

// Valore intermedio: a progress 1 restituisce SEMPRE il valore reale (nessun arrotondamento)
export const countUpValue = (target, progress) => {
  if (typeof target !== 'number' || !isFinite(target)) return target;
  if (progress >= 1) return target;
  if (progress <= 0) return 0;
  return target * countUpEase(progress);
};

// Anima da 0 al valore solo al PRIMO valore numerico ricevuto dopo il mount.
// Refetch, polling e cambio profilo passano direttamente al valore reale.
export const useCountUp = (value, enabled = true) => {
  const [display, setDisplay] = useState(typeof value === 'number' ? (enabled ? 0 : value) : value);
  const animatedOnce = useRef(false);
  const frame = useRef(null);

  useEffect(() => {
    if (typeof value !== 'number' || !isFinite(value)) {
      setDisplay(value);
      return;
    }
    if (!enabled || animatedOnce.current || value === 0) {
      animatedOnce.current = true;
      setDisplay(value);
      return;
    }
    animatedOnce.current = true;
    const reduce = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;
    if (reduce) {
      setDisplay(value);
      return;
    }
    const start = performance.now();
    const step = (now) => {
      const progress = Math.min(1, (now - start) / COUNT_UP_DURATION);
      setDisplay(countUpValue(value, progress));
      if (progress < 1) frame.current = requestAnimationFrame(step);
    };
    frame.current = requestAnimationFrame(step);
    return () => frame.current && cancelAnimationFrame(frame.current);
  }, [value, enabled]);

  return display;
};
